import { Button, Paper, TextInput, NumberInput, Select, Stack } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAddSubCategory, useUpdateSubCategory } from "../../../utils/mutations";
import { useSubcateogryById } from "../../../utils/queries";
import useStore from "../../../utils/store";

const AddSubCategory = () => {
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;

  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [imageType, setImageType] = useState(null);

  useEffect(() => {
    if (id && !user?.updateSubcategory) {
      notifications.show({ message: "You don't have permission to edit subcategories", color: "red" });
      navigate("/categories");
    } else if (!id && !user?.addSubcategory) {
      notifications.show({ message: "You don't have permission to add subcategories", color: "red" });
      navigate("/categories");
    }
  }, [id, user]);

  const { isPending, mutate } = useAddSubCategory();
  const { isPending: isUpdating, mutate: update } = useUpdateSubCategory();
  const { data, isLoading } = useSubcateogryById(params.id);

  useEffect(() => {
    if (data) {
      setName(data.name || "");
      setPosition(data.position || "");
      setImageType(data.imageType || null);
    }
  }, [data]);

  if (!user?.addSubcategory && !user?.updateSubcategory) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const values = { name, position, imageType };
    if (id) update({ id, data: values });
    else mutate({ ...values, categoryId: params.cat });
  };

  return (
    <>
      <Paper
        withBorder
        p="md"
        loading={isLoading}
        style={{ maxWidth: 500, width: "100%", marginInline: "auto" }}
      >
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <NumberInput label="Position" value={position} onChange={setPosition} />
            <TextInput label="Name" value={name} onChange={(e) => setName(e.target.value)} required />
            <Select
              label="Image Type"
              placeholder="Select image type"
              value={imageType}
              onChange={setImageType}
              data={[{ value: "Vertical", label: "Vertical" }, { value: "Horizontal", label: "Horizontal" }]}
            />
            <Button type="submit" loading={isPending || isUpdating}>
              {id ? "Update" : "Add"}
            </Button>
          </Stack>
        </form>
      </Paper>
    </>
  );
};

export default AddSubCategory;
